import { render, staticRenderFns } from "./SegmentedControl.vue?vue&type=template&id=9baa914a&"
import script from "./SegmentedControl.vue?vue&type=script&lang=ts&"
export * from "./SegmentedControl.vue?vue&type=script&lang=ts&"
import style0 from "./SegmentedControl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9baa914a')) {
      api.createRecord('9baa914a', component.options)
    } else {
      api.reload('9baa914a', component.options)
    }
    module.hot.accept("./SegmentedControl.vue?vue&type=template&id=9baa914a&", function () {
      api.rerender('9baa914a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/inputs/SegmentedControl.vue"
export default component.exports